var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-627.000000, -799.000000)",
    fill: "#149BA3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M633.976506,800.318636 C634.406857,800.318636 634.755726,800.649269 634.755726,801.057124 C634.755726,801.439488 634.449103,801.753981 634.056177,801.791799 L633.976506,801.795612 L628.55779,801.795612 L628.55779,810.102982 L637.551931,810.102982 L637.552409,807.384656 C637.552409,807.002291 637.859031,806.687799 638.251957,806.649981 L638.331628,806.646168 C638.735082,806.646168 639.066921,806.936763 639.106825,807.309149 L639.110848,807.384656 L639.110848,810.842047 C639.110848,811.224411 638.804225,811.538904 638.411299,811.576722 L638.331628,811.580534 L627.77922,811.580534 C627.375765,811.580534 627.043927,811.28994 627.004023,810.917553 L627,810.842047 L627,801.057124 C627,800.67476 627.306623,800.360267 627.699549,800.322449 L627.77922,800.318636 L633.976506,800.318636 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.416667,799.552841 C640.738833,799.552841 641,799.800356 641,800.105682 L641,802.450373 C641,802.755698 640.738833,803.003214 640.416667,803.003214 C640.262222,803.003214 640.11408,802.945167 640.004728,802.841802 L639.3095,802.184916 L632.551344,808.276508 C632.23949,808.557567 631.746271,808.545818 631.449709,808.250265 C631.172918,807.974415 631.165265,807.548836 631.419024,807.264806 L631.4774,807.206215 L638.205833,801.141706 L637.524223,800.497111 C637.296119,800.281496 637.295635,799.931457 637.523142,799.715277 C637.632582,799.611286 637.781187,799.552841 637.936161,799.552841 L640.416667,799.552841 Z",
    id: "Path"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkLogo);
export default __webpack_public_path__ + "static/media/link_logo.c9efd60e.svg";
export { ForwardRef as ReactComponent };